{
  "roles_list_page": {
    "title": "Roles",
    "description": "Manage permissions and access levels for your sales team.",
    "footer": "Learn more about roles",
    "create_button": "Create role",
    "table": {
      "headings": {
        "name": "Name",
        "type": "Type",
        "assigned": "Assigned",
        "actions": "Actions"
      },
      "assigned_count": "{count, plural, =1 {# agent} other {# agents}}",
      "type_system": "System role",
      "type_custom": "Custom role"
    },
    "sections": {
      "sales_rep_roles": "Sales agent roles",
      "company_roles": "Company roles"
    }
  },
  "role_form_page": {
    "create_title": "Create role",
    "edit_title": "Edit {name}",
    "role_details": "Role details",
    "role_details_description": "This appears as an option when assigning roles to your sales team.",
    "name_label": "Name",
    "slug_label": "Slug",
    "display_name_label": "Name",
    "display_name_placeholder": "e.g. Rep on the road",
    "handle_label": "Handle (or ID)",
    "handle_placeholder": "e.g. rep-on-the-road",
    "type_label": "Type",
    "type_customer": "Company role",
    "type_sales": "Sales agent role",
    "permissions": "Permissions",
    "permissions_description": "Customise access levels for this role.",
    "delete_confirm_title": "Delete role?",
    "delete_confirm_body": "Are you sure you want to delete \"{name}\"? This can't be undone."
  },
  "list_page": {
    "title": "Customers",
    "heading": "Customers",
    "footer": "Learn more about customers",
    "description": "List of all customers that can place B2B orders on your store.",
    "customers_table": {
      "caption": "Your customers"
    },
    "empty_state": {
      "title": "No customers found",
      "subtitle": "List of all customers that can place B2B orders on your store."
    }
  },
  "sales_agent_overview_page": {
    "title": "Sales agents",
    "heading": "Sales team",
    "footer": "Learn more about sales agents",
    "description": "Sales agents can place orders and manage accounts on behalf of your B2B customers.",
    "customers_table": {
      "caption": "Your agents"
    },
    "empty_state": {
      "no_agents_available": {
        "title": "Sales agents are not included in your plan",
        "subtitle": "Upgrade your plan to start using sales agents to place orders on behalf of your customers."
      },
      "agents_available": {
        "title": "No sales agents found",
        "subtitle": "Add sales agents to your team to start managing orders on behalf of your customers.",
        "add_button": "Add sales agent"
      }
    }
  },
  "customer_details_page": {
    "description": "This information is pulled from your connected platform.",
    "footer": "Learn more about customer metafields",
    "company_user_alert": {
      "main": {
        "title": "Standard company user",
        "message": "This customer belongs to a company account with shared orders, shopping lists, and addresses. They can place orders and view all account activity."
      },
      "limited": {
        "title": "Limited company user",
        "message": "This customer belongs to a company account with shared orders, shopping lists, and addresses. They can add items to orders but can't complete checkout — all orders require approval from the company account owner."
      }
    },
    "information": {
      "title": "Basic information",
      "email": "Email",
      "company": "Company",
      "customer_group_slug": "Customer group",
      "price_lists": "{length, plural, one {Price list override} other {Price list overrides}}",
      "sales_agent_groups": "{length, plural, one {Sales agent group} other {Sales agent groups}}"
    },
    "view_in_platform": "View in {platform}"
  },
  "staff_customer_sync_page": {
    "title": "Customer sync - staff",
    "heading": "Customer sync - staff",
    "footer": "Learn more about customers",
    "description": "View and manage customer sync.",
    "search_placeholder": "Search external_id…",
    "customers_table": {
      "caption": "Your customers"
    },
    "empty_state": {
      "title": "No customers found",
      "subtitle": "Customers that can place B2B orders on your store show here once they sync."
    },
    "actions": {
      "manual_sync": "Manually synchronise customers"
    }
  },
  "customers_sync_page": {
    "title": "Customer sync",
    "description": "This synchronises customer data from your eCommerce platform.",
    "lookup_title": "Customer data lookup",
    "lookup_description": "You can search and diagnose the customer data you're sending to SparkLayer below.",
    "search_placeholder": "Enter customer ID",
    "not_found": {
      "title": "Customer not found",
      "description": "Sorry, no customer was found for the customer ID \"{identifier}\". Please try searching again."
    },
    "search_table": {
      "caption": "Customer search results",
      "headings": {
        "customer": "Customer",
        "external_id": "External ID"
      }
    },
    "summary": {
      "title": "Customer summary",
      "full_name": "Full name",
      "email": "Email",
      "external_id": "External ID",
      "internal_id": "Internal ID"
    },
    "details": {
      "title": "Customer details",
      "view_in_platform": "View customer in {platform}"
    },
    "sales_agent_upsell": {
      "title": "Your SparkLayer plan comes with sales agents",
      "description": "With our sales agent feature you can place orders and manage accounts on behalf of your customers.",
      "upgrade": "Upgrade today"
    },
    "actions": {
      "manual_sync": "Manually synchronise customers",
      "save_role": "Save"
    },
    "notifications": {
      "sync_started": "Customer synchronisation started.",
      "role_updated": "Successfully changed the customer's role.",
      "role_update_limit_error": "Your plan limit of sales agents has been hit. Please check your plan or contact support.",
      "system_error": "A system error occurred. Please wait a few minutes and try again."
    }
  },
  "customer_sync_data_page": {
    "title": "Customer data",
    "description": "The customer data SparkLayer holds for customer ID \"{identifier}\"."
  },
  "sales_agents_page": {
    "title": "Sales agents",
    "description": "Sales agents can place orders and manage accounts on behalf of your B2B customers.",
    "lookup_title": "Manage your sales agents",
    "lookup_description": "To get started and assign a sales agent, you can use the \"Customer data lookup\" tool below.",
    "upsell": {
      "title": "Empower your sales team",
      "subtitle": "Tired of juggling phone orders and endless email threads from customers wanting to place wholesale orders? SparkLayer's sales agent tool puts you in the driver's seat and lets you place and manage B2B orders through your website.",
      "use_cases": {
        "place_orders": {
          "title": "Place B2B orders for your customers",
          "description": "Log in on behalf of your customers and easily place orders for them."
        },
        "offline_orders": {
          "title": "Manage offline orders",
          "description": "Use this tool for placing B2B phone orders or in-person trade show orders."
        },
        "reorder": {
          "title": "Quickly reorder for your customers",
          "description": "Log in to their account, view order history, and repeat orders in seconds."
        }
      }
    }
  }
}
